import TermCreateEdit from "../AdminTermCreateEdit";

export default class AdminTermCreateEditNotificationStatus extends TermCreateEdit {
  /**
   * @returns {string} The term type.
   */
  getType() {
    return "notification_status";
  }
}
